'use strict';

/* global MobileDetect*/

let info = null;

function detectBrowser(){
    if(!info){
        info = new MobileDetect(window.navigator.userAgent);
    }
}

detectBrowser();

export {
    info
};